import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetSupportDetail } from "../redux/actions/teams/members/GetSupportDetailAction";
import { UpdateSupportStatus } from "../redux/actions/teams/members/UpdateSupportStatusAction";

const SupportDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { loading, response, error } = useSelector((state) => state.getSupportDetail);
  const {
    loading: updateLoading,
    response: updateResponse,
    error: updateError,
  } = useSelector((state) => state.updateSupportStatus);

  useEffect(() => {
    if (id) {
      dispatch(GetSupportDetail(id));
    }
  }, [dispatch, id, updateResponse]); // re-fetch after update

  const handleResolve = () => {
    dispatch(UpdateSupportStatus(id));
  };

  if (loading) return <div className="p-4 text-center">Loading...</div>;
  if (error) return <div className="p-4 text-center text-danger">{error.data}</div>;

  const details = response?.data;

  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-4">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <div className="bg-white shadow rounded p-4">
                {/* Title */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="fw-bold mb-0">Support Detail</h5>
                  <button
                    className="btn-close"
                    onClick={() => window.history.back()}
                  ></button>
                </div>

                {/* User Info */}
                <div className="row mb-3">
                  <div className="col-12 col-md-6">
                    <label className="text-muted">Username</label>
                    <div className="fw-semibold">{details?.name}</div>
                  </div>
                  <div className="col-10 col-md-5 text-md-end">
                    <label className="text-muted">Email Address</label>
                    <div className="fw-semibold">{details?.email}</div>
                  </div>
                </div>

                {/* Status */}
                <div className="mb-3">
                  <label className="text-muted">Status</label>
                  <div className="fw-semibold">{details?.statuss}</div>
                </div>

                {/* Message */}
                <div className="mb-3">
                  <label className="text-muted">Message</label>
                  <p className="mb-0">{details?.message}</p>
                </div>

                {/* Checkbox */}
                <div className="form-check mt-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="resolveCheck"
                    checked={details?.statuss === "Resolve"}
                    disabled={details?.statuss === "Resolve" || updateLoading}
                    onChange={handleResolve}
                  />
                  <label className="form-check-label" htmlFor="resolveCheck">
                    Mark as Resolved
                  </label>
                </div>

                {updateError && (
                  <div className="text-danger mt-2">{updateError.data}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SupportDetails;
